import { Lock, LockOpen, PanoramaFishEye } from '@mui/icons-material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Box from '@mui/material/Box';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import MiViewMenu from '../MiViewMenu/MiViewMenu';
import useMiViewTacticCard from './MiViewTacticCard.hook';
import {
  cardWrapperStyle,
  iconBlockStyle,
  iconStyle,
  actionOrderBoxStyle,
  versionBoxStyle,
  percentBoxStyle,
  tacticGeneralInfoBlock,
  channelBoxStyle,
  dateBoxStyle,
  descriptionBoxStyle,
  subtitleStyle,
  lockBoxStyle,
  lockIconStyle,
  menuBoxStyle,
  menuButtonStyle,
  menuIconStyle,
  groupSubtitleIconStyle,
  groupSubtitleStyle,
} from './MiViewTacticCard.style';
import { MiViewTacticCardProps } from './MiViewTacticCard.types';
import { Channel } from 'generated/maya.types';

const MiViewTacticCard: FC<MiViewTacticCardProps> = ({ tactic, tactics, IVADocuments, AEDocuments }) => {
  const { t } = useTranslation();
  const {
    formatDateToMMDDYYYY,
    getSubtitle,
    getChannel,
    getIconByChannel,
    tacticCardConfig,
    getSubtitlesForGroup,
  } = useMiViewTacticCard(tactic, tactics, IVADocuments, AEDocuments);

  const ChannelIcon = getIconByChannel();

  if (!tactic?.actionOrder) return null;

  return (
    <Box sx={ cardWrapperStyle }>
      <Box sx={ iconBlockStyle } width="40px">
        { ChannelIcon && <ChannelIcon sx={ iconStyle }></ChannelIcon> }
        <Box sx={ actionOrderBoxStyle }>{ tactic?.actionOrder }</Box>
        { tactic.channel !== Channel.group ? (<Box sx={ versionBoxStyle }>v{ tactic?.version }</Box>) : null }
        <Box sx={ percentBoxStyle }>{ t('maya_miview_percents_label') }</Box>
      </Box>

      <Box sx={ tacticGeneralInfoBlock } width="25%">
        <Box sx={ channelBoxStyle }>{ getChannel() }</Box>
        <Box sx={ dateBoxStyle }>{ formatDateToMMDDYYYY(tactic?.dateStart) } -<br/> { formatDateToMMDDYYYY(tactic?.dateEnd) }</Box>
      </Box>

      <Box sx={ descriptionBoxStyle } width="40%">
        { tactic.channel === Channel.group ? null : (<Box>{ tactic?.title }</Box>) }
        {
          tactic.channel === Channel.group ? (
            getSubtitlesForGroup()?.map((subtitle, index) => (
              <Box key={ index } sx={ groupSubtitleStyle }>
                <PanoramaFishEye sx={ groupSubtitleIconStyle }></PanoramaFishEye>
                { subtitle }
              </Box>
            ))
          ) : (
            <Box sx={ subtitleStyle }>{ getSubtitle() }</Box>
          )
        }
      </Box>

      <Box sx={ menuBoxStyle }>
        <Box sx={ lockBoxStyle }>
          { tactic.mandatory ? <Lock sx={ lockIconStyle } /> : <LockOpen sx={ lockIconStyle } /> }
        </Box>
        <MiViewMenu
          menuList={ tacticCardConfig.menuList }
          buttonStyle={ menuButtonStyle }
          tooltipMessage={ t('maya_miview_menu_action_tooltip') }
        >
          <MoreVertIcon sx={ menuIconStyle }/>
        </MiViewMenu>
      </Box>
    </Box>
  );
};

export default MiViewTacticCard;
